<script>

import VCombobox from 'vuetify/lib/components/VCombobox/VCombobox';

export default {
  extends: VCombobox,
  props: {
    autoSelectIndex: {
      type: Number,
      default: null,
    },
    alwaysShowValue: {
      type: String,
      default: null
    },
    filter: {
      type: Function,
      default: function (item, queryText, itemText) {
        return (this.alwaysShowValue !== null && item[this.itemValue] === this.alwaysShowValue) ||
          itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      }
    },
  },
  computed:{
     filteredItems (){
      //overwriting computed property of vuetify 2.x VAutocomplete 
      if (!this.isSearching || this.noFilter || this.internalSearch == null) return this.allItems;
      const alphasorted =  this.allItems.filter(item => this.filter(item, String(this.internalSearch), String(this.getText(item))));
      //we can be lazy(fast) on sorting because alphasorted is supposed to be sorted
      //This SORT implies items to be an aarray of STRINGS - else a.name should be sorted
      return alphasorted.sort((a, b) => (a.toLowerCase().startsWith(this.internalSearch.toLowerCase()) 
                                      && !b.toLowerCase().startsWith(this.internalSearch.toLowerCase())) 
                                      ? -1 
                                      : 1);
    },
  },
  watch: {
    filteredItems: 'onFilteredItemsChanged'
  },
  methods: {
    onFilteredItemsChanged (val, oldVal) {
      if (val === oldVal) return;

      this.setMenuIndex(-1);

      this.$nextTick(() => {
        if (
          !this.internalSearch ||
          (val.length !== 1 &&
            !this.autoSelectFirst &&
            isNaN(this.autoSelectIndex))
        ) return;

        this.$refs.menu.getTiles();
        const currentAutoSelectFix = ( this.autoSelectIndex && this.filteredItems && this.filteredItems[0] && !this.filteredItems[0].name.startsWith('--') ) ? -1 : 0;
        this.setMenuIndex(isNaN(this.autoSelectIndex) || (this.filteredItems.length - 1) < this.autoSelectIndex ? 0 : this.autoSelectIndex + currentAutoSelectFix);
      });
    }
  }

};

</script>
